var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markRecommend"},[_c('a',{attrs:{"id":"auto","href":'line://msg/text/?一起加入好友%0D%0Aline://app/1653867330-D1v8MvzE?keyword=_&c='+this.channelId+'&rec='+this.userId},on:{"click":_vm.recommend}}),_vm._v(" "),_c('img',{attrs:{"src":require("../assets/mark.png")}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c54222cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/markRecommend.vue
// module id = null
// module chunks = 